import { onFontsReady } from "../utils/onFontsReady";
import { initFontsGate } from "../utils/initFontsGate";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
initFontsGate("Manrope", [400, 700]);

function initHeroForm(section) {
	if (!section || section.dataset.gsapHeroFormInited) return;
	section.dataset.gsapHeroFormInited = "1";

	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

	const content = section.querySelector(".wv-hero-content");
	const formWrap = section.querySelector(".section-form-shortcode");
	const placeholder = section.querySelector(".section-placeholder-img");

	const items = content ? Array.from(content.children) : [];

	// стартовые состояния
	if (items.length) gsap.set(items, { opacity: 0, y: 14 });
	if (formWrap) gsap.set(formWrap, { opacity: 0 });
	if (placeholder) gsap.set(placeholder, { opacity: 0, y: 6 });

	const tl = gsap.timeline({
		defaults: { ease: "power2.out" },
	});

	if (items.length) {
		tl.to(items, {
			opacity: 1,
			y: 0,
			duration: 0.75,
			stagger: 0.2,
			clearProps: "transform,opacity",
		});
	}

	// форма — мягко проявить (без сдвигов)
	if (formWrap) {
		tl.to(
			formWrap,
			{
				opacity: 1,
				duration: 0.9,
				ease: "power1.out",
				clearProps: "opacity",
			},
			items.length ? "-=0.55" : 0
		);
	}

	if (placeholder) {
		tl.to(
			placeholder,
			{
				opacity: 1,
				y: 0,
				duration: 0.9,
				ease: "power1.out",
				clearProps: "transform,opacity",
			},
			"-=0.7"
		);
	}

	// Hero обычно сразу на экране — но пусть всё равно будет через ScrollTrigger (на случай повторов ниже)
	ScrollTrigger.create({
		trigger: section,
		start: "top 85%",
		once: true,
		onEnter: () => tl.play(0),
	});
}

onFontsReady(() => {
	document.querySelectorAll(".wv-hero-form").forEach(initHeroForm);
	ScrollTrigger.refresh();
});
